
// --------------------------------------------------------------------------
// #109 - Input number - Manual Increment/decrement of form input
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function () {

    var maxNumber = 999;

    function init() {

        $('[data-binding="bird-item"]').each(function () {
            $(this).one('click', function (e) {
                e.stopPropagation();
                $(this).find('[data-binding="increase-number"]').trigger('click');
            });
        });

        $('body').on('click', '[data-binding="increase-number"]', function (e) {
            e.preventDefault();

            var $input = $(this).prev('input');
            var $decreaseButton = $(this).siblings('[data-binding="decrease-number"]');
            var $item = $(this).parents('[data-binding="bird-item"]');

            $input.val(function (i, oldval) {
                if (oldval < maxNumber) {
                    return ++oldval;
                } else {
                    return oldval;
                }
            });

            if ($(this).parent().hasClass('number-of-adults')) {
                $(this).parent().next().removeClass('field-validation-error').addClass('field-validation-valid').text('');
            }

            if ($(this).parent().attr('data-hidden')) {
                $decreaseButton.show();
                $input.show();
                $item.addClass('active');
            } else {
                $decreaseButton.removeClass('disabled');
            }
        });

        $('body').on('click', '[data-binding="decrease-number"]', function (e) {
            e.preventDefault();

            var $input = $(this).siblings('input[type="number"], input[type="text"]');
            var currentVal = $input.val();
            var $decreaseButton = $(this);
            var $item = $(this).parents('[data-binding="bird-item"]');

            if (currentVal > 0) {
                $input.val(function (i, oldval) {
                    return --oldval;
                });
            }

            if ($(this).parent().hasClass('number-of-adults') && currentVal <= 1) {
                $(this).parent().next().removeClass('field-validation-valid').addClass('field-validation-error').text('The number of adults taking part must be one or more.');
            }

            if ($(this).parent().attr('data-hidden') && $decreaseButton.is(':visible') && currentVal <= 1) {
                $decreaseButton.hide();
                $input.hide();
                $item.removeClass('active');
            } else {
                if (currentVal <= 1) {
                    $decreaseButton.addClass('disabled');
                }
            }
        });

        $('body').on('focusout', '[data-binding="input-number"]', function () {
            $(this).val(function (i, oldval) {
                if (oldval <= maxNumber) {
                    return oldval;
                } else {
                    return maxNumber;
                }
            });
        });

        $('body').on('keypress', '[data-binding="input-number"]', function (e) {
            var charCode = e.which ? e.which : event.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return false;
            }

            return true;
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/input-number.js
// module id = 224
// module chunks = 0